import { FinderSearchWindowHours } from '../constants'

function toTime(totalMinutes: number) {
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}

/**
 * The finder's `from`/`until` window around the requested time, kept inside
 * the same day so it never wraps past midnight
 */
export default function getFinderSearchWindow(time: string): {
  from: string
  until: string
} {
  const [hours, minutes] = time.split(':').map(Number)
  const requested = hours * 60 + minutes
  const span = FinderSearchWindowHours * 60

  return {
    from: toTime(Math.max(0, requested - span)),
    until: toTime(Math.min(23 * 60 + 59, requested + span)),
  }
}
